export default "__VITE_ASSET__DAIJUN2l__"